
import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({

  props: {
    data: {
      type: Object as () => {
        cols: number
        rows: number
        cells: {
          existed: boolean
          isReefer: boolean
          is45Foot: boolean
          isTank: boolean
          isFlatRack: boolean
          isOpenTop: boolean
          isPlatform: boolean
          isLoadedWrongPosition: boolean
          yardPlanningIsObserved: boolean
        }[]
      },
      default: () => ({
        cols: 5,
        rows: 5,
        cells: [{
          existed: true,
          isReefer: true,
          is45Foot: true,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }, {
          existed: false,
          isReefer: true,
          is45Foot: false,
          isTank: false,
          isFlatRack: false,
          isOpenTop: false,
          isPlatform: false,
        }]
      })
    },
    name: {
      type: String,
      default: '01'
    },
    vesselMonitoringType: {
      type: String
    },
    minDeckTiersNo: { default: 0 },
    cellWidth: { default: null }
  },
  data() {
    return {
      SPACE_BETWEEN_CELLS: 0,
      OffsetbayX :0,
      blinkColor: '#FF0000',
      textConfig: {
        fontSize: 10,
        fill: '#000000',
      },
    }
  },
  watch: {
    cellWidth(newVal) {
      if (newVal) this.cellWidth = Number(newVal)
    }
  },
  mounted() {
    //this.startBlinking();
    if (this.cellWidth) this.cellWidth = Number(this.cellWidth)
  },
  methods: {
    ...mapActions(["setVesselMonitoringContainerDetail", "setWrong", 'setIsVesselMonitoringContainerDetailModalOpen']),
    handleCellClick(containerData) {
        if (!containerData.existed) return
      this.setVesselMonitoringContainerDetail(containerData)
      this.setIsVesselMonitoringContainerDetailModalOpen(true)
    },
    handleMouseOver(container, evt) {
      if (container.existed) {
        evt.target.style.stroke = '#000000';
        evt.target.style.strokeWidth = '1';
        document.body.style.cursor = 'pointer';
      }
    },
    handleMouseOut(container, evt) {
      if (container.existed) {
        evt.target.style.stroke = '#A0A0A0';
        evt.target.style.strokeWidth = '0.3';
        document.body.style.cursor = 'default';
      }
    },
    getXLabels() {
      const labels: string[] = []
      const middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      const startNumber = this.data.cols % 2 === 0 ? 1 : 0

      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }

      return labels.filter((label) => label !== undefined)
    },
    getYLabels() {
      const labels: (string | undefined)[] = []
      for (let i = this.data.rows - 1; i >= 0; i--) {
        labels.push((this.minDeckTiersNo + i * 2).toString())
      }
      return labels.filter((label) => label !== undefined) as string[]
    },
    startBlinking() {
      setInterval(() => {
        this.blinkColor =
          this.blinkColor === this.hexToRGBA('#FF0000', 1)
            ? this.hexToRGBA('#ffffff', 1)
            : this.hexToRGBA('#FF0000', 1);
      },
        1000
      );
    },
    hexToRGBA(hex: string, alpha: number = 1): string {
      const match = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      if (!match) {
        throw new Error("Invalid hex format!");
      }
      const [_, r, g, b] = match.map(value => parseInt(value, 16));
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
  computed: {
    ...mapGetters(['getVesselMonitoringData', 'getVesselMonitoringType','getShowWeightLevel']),
    ShowWeightLevel: {
      get() {
        return this.getShowWeightLevel;
      }},
    svgWidth() {
      return  this.data.cols * this.cellWidth + 20;
    },
    svgHeight() {
      return this.data.rows * (this.cellWidth + this.SPACE_BETWEEN_CELLS) + 25;
    },
    containers() {
      const cols = this.data.cols
      const rows = this.data.rows
      let stroke = '#A0A0A0'
      let hoverStroke = '#000000'
      let strokeWidth = 0.3
      let hoverStrokeWidth = 1
      const newContainers = this.data.cells.map((c, index) => {
        let fill = c.color === null ? '#fafafa' : `#${c.color}`

        let cellData = {
          ...c,
          id: c.id,
          index,

          x: (index % cols) * (this.cellWidth + this.SPACE_BETWEEN_CELLS) + this.OffsetbayX,
          y: (rows - 1 - Math.floor(index / cols)) * (this.cellWidth) + 20,
          width: this.cellWidth,
          height: this.cellWidth,
          fill: fill,

          stroke: stroke,
          strokeWidth: strokeWidth,
          type: 'standard',
          onmouseover(evt) {
            if (c.existed) {
              const shape = evt.target
              shape.stroke(hoverStroke)
              shape.strokeWidth(hoverStrokeWidth)
              document.body.style.cursor = 'pointer'
            }
          },
          onmouseout(evt) {
            const shape = evt.target
            document.body.style.cursor = 'default'
            shape.stroke(stroke)
            shape.strokeWidth(strokeWidth)
          },

        }
        if (c.isInBay === false) {
          cellData = {
            ...cellData,
            strokeWidth: 0,
            fill: '#ffffff',
            onmouseover: () => { },
            onmouseout: () => { }
          }
        }
        if ((this.getVesselMonitoringType === "Load" && c.isLoadedWrongPosition) || (this.getVesselMonitoringType === "Discharge" && c.yardPlanningIsObserved != null && !c.yardPlanningIsObserved)) {
          cellData = {
            ...cellData,
            strokeWidth: 3,
            stroke: this.blinkColor,
            onmouseover: () => { },
            onmouseout: () => { }
          }
        }



        return cellData
      })
      return newContainers
    },

  }
})
